import useWidth from '@/helpers/widthUtil';
import { Badge, Breadcrumb, Rate, Tag } from 'antd';
import { HeartFilled, HeartOutlined } from '@ant-design/icons';
import { Fragment, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { addCourseToWishList } from '@/actions/courses';
import { ButtonSection, CoursePrice, RequestCallSection } from './DetailsCard';
import { DetailsContext } from '.';

const CourseBanner = () => {
  const { isMobile } = useWidth();
  const dispatch = useDispatch();
  const { course, courseEnroll, auth, isStickyMenu } = useContext(DetailsContext);

  const showWishlist = auth && !courseEnroll?.is_enroll;
  const onHeartClick = (slug) => {
    dispatch(addCourseToWishList(slug));
  };

  const Tagdata = (data: any, classN?: string) => (
    <Tag
      color="rgb(220 31 38 / 40%)"
      className={`text-white banner-tags mt-2 ${classN}`}
    >
      {data}
    </Tag>
  );

  const BreadcrumbData = () => (
    <Breadcrumb className="text-white">
      <Breadcrumb.Item>
        <a href="/">Home</a>
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <a href="/course">Courses</a>
      </Breadcrumb.Item>
      <Breadcrumb.Item>{course?.name}</Breadcrumb.Item>
    </Breadcrumb>
  );

  return (
    <Fragment>
      {isMobile && (
        <div className="bg-white p-2 px-5 text-center">
          <CoursePrice />
          <div className="py-2 d-inline-flex flex-column">
            <ButtonSection />
            <RequestCallSection />
          </div>
        </div>
      )}
      <div className="row m-0 course-desktop-banner d-sm-block d-lg-block d-md-block">
        <div className="custom-container course-details-banner mb-3 d-flex align-items-center">
          <div className={`my-3 pl-1 ${isMobile ? '' : 'pt-5'}`}>
            <div className="d-flex flex-column montserrat-font-family">
              {!isMobile && <BreadcrumbData />}
              <h1 className="text-white montserrat-font-family mt-3 banner-h1 d-flex align-items-center">
                {course?.name}
                {showWishlist ? (
                  courseEnroll?.wishlist ? (
                    <HeartFilled
                      rev=""
                      className="text-danger cursor-pointer ml-4"
                      style={{ fontSize: '26px' }}
                      title="Remove from wishlist"
                      onClick={() => onHeartClick(course?.slug)}
                    />
                  ) : (
                    <HeartOutlined
                      rev=""
                      className={'text-white mt-1 ml-4 pb-2 cursor-pointer'}
                      style={{ fontSize: '26px' }}
                      title="Add to wishlist"
                      onClick={() => onHeartClick(course?.slug)}
                    />
                  )
                ) : (
                  ''
                )}
              </h1>
              {(course?.total_feedback != 0 ||
                course?.coming_soon ||
                course?.total_enroll >= 20) && (
                <div className="d-flex mb-3">
                  <>
                    {course?.coming_soon ? (
                      <>
                        <Badge className="p-1 h-25 mt-2 bg-danger shadow-lg rounded">
                          <span
                            className="font-weight-bold text-white"
                            style={{ fontSize: '13px' }}
                          >
                            Coming Soon
                          </span>
                        </Badge>
                      </>
                    ) : (
                      <span className="course-rating d-flex justify-content-between mt-1">
                        {course?.total_feedback != 0 ? (
                          <>
                            <Rate
                              disabled
                              allowHalf
                              defaultValue={course?.average_rating}
                              style={{
                                cursor: 'pointer',
                                fontSize: '16px',
                                color: '#FABB02',
                                marginTop: '2px',
                              }}
                            />
                            <small
                              className="ml-2 mt-auto text-white"
                              style={{
                                fontSize: '16px',
                              }}
                            >
                              {course?.average_rating?.toFixed(1)}
                            </small>
                            <small
                              className="ml-2 mt-auto text-white reviewtip"
                              style={{
                                fontSize: '16px',
                              }}
                            >
                              ({course?.total_feedback})
                              <span className="tooltiptext">No. of Review</span>
                            </small>
                          </>
                        ) : null}
                      </span>
                    )}
                  </>
                </div>
              )}
              <div className="d-flex text-dark flex-wrap">
                {Tagdata('Materials Included', 'mr-3')}
                {course?.live && Tagdata('Recorded Live', 'mr-3')}
                {course?.duration && Tagdata(`Duration: ${course?.duration}`)}
              </div>
            </div>
          </div>
        </div>
      </div>
      {isStickyMenu && !isMobile ? <div className="border-line" /> : ''}
    </Fragment>
  );
};

export default CourseBanner;
